import { deleteRequest, get, patch, post } from "utilities/network";

export const httpGetUserVirtualCards = (userId: string) => {
  return get(`admin/virtual-card/users/${userId}/cards`);
};

export const httpGetVirtualCardTransactions = (
  virtualCardId: string,
  page: number = 1,
  limit: number = 20,
) => {
  return get(
    `admin/virtual-card/cards/${virtualCardId}/transactions?page=${page}&limit=${limit}`,
  );
};

export const httpGetVirtualCardDetail = (virtualCardId: string) => {
  return get(`admin/virtual-card/cards/${virtualCardId}`);
};

export const httpGetVirtualCardDisputes = (
  virtualCardId: string,
  page: number = 1,
  limit: number = 20,
) => {
  return get(
    `admin/virtual-card/cards/${virtualCardId}/disputes?page=${page}&limit=${limit}`,
  );
};

export const httpFreezeVirtualCard = (
  virtualCardId: string,
  freeze: boolean,
  reason?: string,
) => {
  return patch(`admin/virtual-card/cards/${virtualCardId}/freeze`, {
    freeze,
    reason,
  });
};

export const httpDeleteVirtualCard = (
  virtualCardId: string,
  reason?: string,
) => {
  return deleteRequest(`admin/virtual-card/cards/${virtualCardId}`, { reason });
};

export const httpGetVirtualCardStats = () => {
  return get(`admin/virtual-card/stats`);
};

interface GetVirtualCardsParams {
  lastName?: string;
  activated?: boolean;
  terminated?: boolean;
  FromDate?: string;
  ToDate?: string;
  PageNumber?: number;
  PageSize?: number;
  CustomerId?: string;
  cardId?: string;
}

export const httpGetVirtualCardsList = (params?: GetVirtualCardsParams) => {
  const queryParams = new URLSearchParams();
  if (params) {
    if (params.lastName) queryParams.append("lastName", params.lastName);
    if (params.activated !== undefined)
      queryParams.append("activated", String(params.activated));
    if (params.terminated !== undefined)
      queryParams.append("terminated", String(params.terminated));
    if (params.FromDate) queryParams.append("FromDate", params.FromDate);
    if (params.ToDate) queryParams.append("ToDate", params.ToDate);
    if (params.PageNumber)
      queryParams.append("PageNumber", String(params.PageNumber));
    if (params.PageSize)
      queryParams.append("PageSize", String(params.PageSize));
    if (params.CustomerId) queryParams.append("CustomerId", params.CustomerId);
    if (params.cardId) queryParams.append("cardId", params.cardId);
  }
  const queryString = queryParams.toString();
  const url = `admin/virtual-card/cards${queryString ? `?${queryString}` : ""}`;
  return get(url);
};

export const httpCreateCardDispute = (
  transactionId: string,
  description: string,
) =>
  post(
    `admin/virtual-card/transactions/${encodeURIComponent(transactionId)}/dispute`,
    { description },
  );
export const httpUpdateCardDispute = (
  disputeId: number,
  status: string,
  reason: string,
) =>
  patch(`admin/virtual-card/disputes/${disputeId}/status`, { status, reason });

export const httpRequestCardDisputeFee = (
  disputeId: number,
  providerReference: string,
  reason: string,
) =>
  post(`admin/virtual-card/disputes/${disputeId}/fee`, {
    providerReference,
    userFeeAcknowledged: true,
    reason,
  });
